import { useNavigate } from 'react-router-dom';
import React from 'react';

/**
 * HOC that provides navigate function to class components
 * Usage: export default withNavigation(MyComponent);
 */
const withNavigation = (Component) => {
  return function WrappedComponent(props) {
    const navigate = useNavigate();
    return <Component {...props} navigate={navigate} />;
  };
};

export default withNavigation;
